import Bowser from 'bowser';
import { LINK_FOR_PERSONAL_POLICY } from '~/actions/constants';
import RS from '~/api';
import { origin } from '~/api/Services';
import { ObserverOnResize } from '~/utils/ObserverOnResize';
import PausableTimer from '~/utils/PausableTimer';

const { platform } = Bowser.parse(window.navigator.userAgent);

let timer;
export let iterator = 0;
export const _ = '__csa-';

export const place = {
  bottomCenter: 'bottom-center',
  bottomLeft: 'bottom-left',
  bottomRight: 'bottom-right',
  center: 'center',
  centerLeft: 'center-left',
  centerRight: 'center-right',
  topCenter: 'top-center',
  topLeft: 'top-left',
  topRight: 'top-right',
};

const tpl = (
  scenarioName,
  {
    title,
    message,
    agreeEnabled = false,
    agreeText = 'Принять',
    agreeLink = '',
    cancelEnabled = false,
    cancelText = 'Отмена',
    closeOnOverlay = true,
    isCustom = false,
    isLightbox = false,
    sameButtonsWidth = true,

    backgroundColor = '#FFF',
    border = '',
    borderRadius = '',
    lightboxTopMargin = '',
    notificationShadow = '0 45px 35px -20px rgba(0, 0, 0, .1)',
    notificationSpeed = '400ms',
    padding = '28px 30px',
    position = isLightbox ? place.center : place.bottomRight,
    width = '450px',

    closeColor = '#9b9b9b',
    closeFontSize = '30px',
    closeFontWeight = 'bold',
    closeHoverColor = '#262626',
    closeRightMargin = '32px',
    closeTopMargin = '31px',

    titleColor = '#000',
    titleFontFamily = `'Open Sans', Helvetica, Arial, sans-serif`,
    titleFontSize = '19px',
    titleFontWeight = '600',
    titleLineHeight = '1.26',

    messageColor = '#535353',
    messageFontFamily = `'Open Sans', Helvetica, Arial, sans-serif`,
    messageFontSize = '17px',
    messageFontWeight = '',
    messageLineHeight = '1.41',

    buttonBackgroundColor = 'transparent',
    buttonBorder = '1px solid #262626',
    buttonBorderRadius = '2px',
    buttonFontFamily = '',
    buttonFontSize = '15px',
    buttonFontWeight = '600',
    buttonHoverBorderColor = '#19bb4f',
    buttonHoverColor = '',
    buttonHoverTextColor = '#19bb4f',
    buttonTextColor = '#262626',

    agreeBorder = '#262626',
    agreeBackgroundColor = '#262626',
    agreeFontWeight = '',
    agreeHoverBorderColor = '#19bb4f',
    agreeHoverColor = '#19bb4f',
    agreeHoverTextColor = '',
    agreeRightMargin = '20px',
    agreeTextColor = '#fff',
  },
  customHTML = '',
  customCSS = ''
) => {
  const style = customCSS
    ? customCSS
    : `
  .${_}notification__close {
    position: absolute;
    display: block;
    right: ${closeRightMargin};
    top: ${closeTopMargin};
    font-size: ${closeFontSize};
    line-height: 20px;
    text-align: center;
    width: 20px;
    height: 20px;
    font-weight: ${closeFontWeight};
    color: ${closeColor};
    cursor: pointer;
    text-decoration: none;
  }

  .${_}notification__close:hover {
    color: ${closeHoverColor};
  }

  .${_}notification__box {
    background-color: ${backgroundColor};
    padding: ${padding};
    margin: 20px;
    box-shadow: ${notificationShadow};
    transition: box-shadow var(--csa-notification-speed-${iterator}) ease;
    ${border && `border: ${border};`}
    ${borderRadius && `border-radius: ${borderRadius};`}
  }

  .${_}notification__title:empty {
    display: none;
  }

  .${_}notification__title {
    font-family: "${titleFontFamily}";
    color: ${titleColor};
    font-size: ${titleFontSize};
    font-weight: ${titleFontWeight};
    line-height: ${titleLineHeight};
  }

  .${_}notification__body:empty,
  .${_}notification__actions:empty {
    display: none;
  }

  .${_}notification__body {
    font-family: "${messageFontFamily}";
    ${messageFontWeight && `font-weight: ${messageFontWeight};`}
    color: ${messageColor};
    font-size: ${messageFontSize};
    line-height: ${messageLineHeight};
    margin-top: 10px;
  }

  .${_}notification__actions {
    display: flex;
    font-family: "${titleFontFamily}";
    margin-top: 20px;
  }

  .${_}notification__button {
    display: flex;
    justify-content: center;
    align-items: center;
    ${sameButtonsWidth ? 'width: 100%;' : ''}
    ${buttonBorderRadius && `border-radius: ${buttonBorderRadius};`}
    text-align: center;
    ${buttonFontFamily && `font-family: "${buttonFontFamily}";`}
    font-size: ${buttonFontSize};
    background-color: ${buttonBackgroundColor};
    background-image: none !important;
    color: ${buttonTextColor};
    border: ${buttonBorder};
    padding: 10px 20px;
    text-decoration: none;
    cursor: pointer;
    font-weight: ${buttonFontWeight};
    transition: background-color 300ms ease-in-out, color 300ms ease-in-out, border-color 300ms ease-in-out;
  }

  .${_}notification__button:hover {
    ${buttonHoverColor && `background-color: ${buttonHoverColor};`}
    border-color: ${buttonHoverBorderColor};
    color: ${buttonHoverTextColor};
  }

  .${_}notification__button._type-primary {
    background-color: ${agreeBackgroundColor};
    border-color: ${agreeBorder};
    color: ${agreeTextColor};
    ${agreeFontWeight && `font-weight: ${agreeFontWeight};`}
    margin-right: ${agreeRightMargin};
  }

  .${_}notification__button._type-primary:hover {
    background-color: ${agreeHoverColor};
    border-color: ${agreeHoverBorderColor};
    ${agreeHoverTextColor && `color: ${agreeHoverTextColor};`}
  }`;

  const layout = customHTML
    ? customHTML
    : `
  <div class="${_}notification__box _position-${position}">
    <a class="${_}notification__close">×</a>
    <div class="${_}notification__title">${
      typeof title === 'string' ? title : 'Внимание'
    }</div>
    <div class="${_}notification__body">${
      typeof message === 'string'
        ? message
        : `Сценарий ${scenarioName} выполнен`
    }</div>
    ${
      cancelEnabled || agreeEnabled
        ? `<div class="${_}notification__actions">
      ${
          agreeEnabled &&
          `<a
        class="${_}notification__button _type-primary"
        href="${agreeLink}"
      >
        ${agreeText}
      </a>`
        }
      ${
          cancelEnabled &&
          `<a class="${_}notification__button _close">
        ${cancelText}
      </a>`
        }
    </div>`
        : ''
    }
  </div>`;

  const lightboxOverlayStyles = `
    width: 100%;
    height: 100%;
    display: flex;
    ${lightboxTopMargin ? `align-items: flex-start;` : 'align-items: center;'}
    justify-content: center;
    background-color: rgba(0,0,0,.6);
  `;

  return `
  <style class="${_}notification-${iterator}-styles">
    :root {
      --csa-notification-speed-${iterator}: ${notificationSpeed};
      --csa-notification-width-${iterator}: ${width};
    }

    .${_}notification-${iterator} {
      position: fixed;
      ${
    isLightbox
      ? lightboxOverlayStyles
      : `width: var(--csa-notification-width-${iterator});`
  }
      transform: translate3d(0, 0, 0);
      transition: transform var(--csa-notification-speed-${iterator}) ease, opacity var(--csa-notification-speed-${iterator}) ease;
      opacity: 1;
      z-index: 999999999999;
    }

    .${_}notification-${iterator},
    .${_}notification-${iterator} * {
      padding: 0;
      margin: 0;
      box-sizing: border-box;
    }

    .${_}notification-${iterator}._hidden {
      opacity: 0;
    }

    .${_}notification-${iterator}._position-bottom-center,
    .${_}notification-${iterator}._position-bottom-right,
    .${_}notification-${iterator}._position-bottom-left,
    .${_}notification-${iterator} .${_}notification__box._position-bottom-center,
    .${_}notification-${iterator} .${_}notification__box._position-bottom-right,
    .${_}notification-${iterator} .${_}notification__box._position-bottom-left {
      bottom: 0;
    }

    .${_}notification-${iterator}._position-top-center,
    .${_}notification-${iterator}._position-top-right,
    .${_}notification-${iterator}._position-top-left,
    .${_}notification-${iterator} .${_}notification__box._position-top-center,
    .${_}notification-${iterator} .${_}notification__box._position-top-right,
    .${_}notification-${iterator} .${_}notification__box._position-top-left {
      top: 0;
    }

    .${_}notification-${iterator}._position-top-left,
    .${_}notification-${iterator}._position-center-left,
    .${_}notification-${iterator}._position-bottom-left,
    .${_}notification-${iterator} .${_}notification__box._position-top-left,
    .${_}notification-${iterator} .${_}notification__box._position-center-left,
    .${_}notification-${iterator} .${_}notification__box._position-bottom-left {
      left: 0;
    }

    .${_}notification-${iterator}._position-top-right,
    .${_}notification-${iterator}._position-center-right,
    .${_}notification-${iterator}._position-bottom-right,
    .${_}notification-${iterator} .${_}notification__box._position-top-right,
    .${_}notification-${iterator} .${_}notification__box._position-center-right,
    .${_}notification-${iterator} .${_}notification__box._position-bottom-right {
      right: 0;
    }

    .${_}notification-${iterator}._position-bottom-center,
    .${_}notification-${iterator}._position-top-center${
    isLightbox
      ? `,
    .${_}notification-${iterator} .${_}notification__box._position-bottom-center,
    .${_}notification-${iterator} .${_}notification__box._position-top-center`
      : ''
  } {
      left: 50%;
      transform: translateX(-50%);
    }

    .${_}notification-${iterator}._position-center${
    isLightbox
      ? `,
    .${_}notification-${iterator} .${_}notification__box._position-center`
      : ''
  } {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    .${_}notification-${iterator}._position-center-left,
    .${_}notification-${iterator}._position-center-right,
    .${_}notification-${iterator} .${_}notification__box._position-center-left,
    .${_}notification-${iterator} .${_}notification__box._position-center-right {
      top: 50%;
      transform: translateY(-50%);
    }

    .${_}notification-${iterator}._position-bottom-right._hidden,
    .${_}notification-${iterator}._position-top-right._hidden {
      transform: translate3d(var(--csa-notification-width-${iterator}), 0, 0);
    }

    .${_}notification-${iterator}._position-bottom-left._hidden,
    .${_}notification-${iterator}._position-top-left._hidden {
      transform: translate3d(calc(-1 * var(--csa-notification-width-${iterator})), 0, 0);
    }

    ${
    isLightbox
      ? `.${_}notification-${iterator} .${_}notification__box {
        ${lightboxTopMargin ? `top: ${lightboxTopMargin};` : ''}
        position: absolute;
        width: var(--csa-notification-width-${iterator});
      }`
      : ''
  },

    ${style}
  </style>

  <div class="${_}notification ${_}notification-${iterator} _position-${position} _hidden">
    ${layout}
  </div>`;
};

const showNotification = (element) => {
  element.classList.remove('_hidden');
};

const hideNotification = (element) => {
  element.classList.add('_hidden');
};

export const configure = (
  scenarioName = '',
  configuration = {},
  customHTML = '',
  customCSS = ''
) => {
  document.body.insertAdjacentHTML(
    'beforeend',
    tpl(scenarioName, configuration, customHTML, customCSS)
  );
  const sessionId = RS.token.sessionId;

  if (configuration.isCustom) {
    RS.scenarioEvent.set('TRIGGER_EVENT', [
      { TRIGGER_UUID: configuration.uuid },
      { TRIGGER_ELEMENT: 'SHOW_WIDGET' },
      { SESSION_ID: sessionId },
    ]);
  }

  const defaultDisplayTimeout = 5000;

  let initialWidth = parseInt(configuration.width, 10);
  let initialHeight = parseInt(configuration.height, 10);

  const timeout =
    typeof configuration.timeout === 'number'
      ? configuration.timeout
      : defaultDisplayTimeout;
  const buttonTimeout =
    typeof configuration.buttonTimeout === 'number'
      ? configuration.buttonTimeout
      : 500;
  const element = document.querySelector(`.${_}notification-${iterator}`);
  const stylesElement = document.querySelector(
    `.${_}notification-${iterator}-styles`
  );
  const box = element.querySelector(
    `.${_}notification-${iterator} .${_}notification__box`
  );
  const closeElement = element.querySelector(
    `.${_}notification-${iterator} .${_}notification__close`
  );
  const agreeButton = element.querySelector(
    `.${_}notification-${iterator} .${_}notification__button._type-primary`
  );
  const coupon = document.querySelector(
    `.${_}notification-${iterator} .${_}notification__coupon`
  );
  const couponOverlay = document.querySelector(
    `.${_}notification-${iterator} .${_}notification__coupon-overlay`
  );
  const couponTextHidden = document.querySelector(
    `.${_}notification-${iterator} .${_}notification__coupon-text._hidden`
  );
  const closeButton = element.querySelector(
    `.${_}notification-${iterator} .${_}notification__button._close`
  );
  const inputWrapper = element.querySelector(
    `.${_}notification-${iterator} .${_}notification__input`
  );
  const input = element.querySelector(
    `.${_}notification-${iterator} .${_}notification__input .${_}input__element`
  );
  const checkboxSquare = element.querySelector(
    `.${_}notification-${iterator} .${_}notification__box .${_}checkbox__square`
  );
  const checkboxWrapper = element.querySelector(
    `.${_}notification-${iterator} .${_}notification__box .${_}checkbox`
  );
  const checkboxInput = element.querySelector(
    `.${_}notification-${iterator} .${_}notification__box .${_}checkbox__input`
  );
  const privacyPolicyLink = element.querySelector(
    `.${_}notification-${iterator} .${_}notification__box .${_}notification__privacy-policy-link`
  );

  timer = new PausableTimer(() => hideNotification(element), timeout);
  initialWidth = box.offsetWidth;
  initialHeight = box.offsetHeight;

  setTimeout(() => {
    if (configuration.isLightbox) {
      box.addEventListener('mouseenter', timer.pause);
      box.addEventListener('mouseleave', timer.resume);
    } else {
      element.addEventListener('mouseenter', timer.pause);
      element.addEventListener('mouseleave', timer.resume);
    }
  }, 500);

  element.addEventListener('transitionend', () => {
    if (element.classList.contains('_hidden')) {
      try {
        document.body.removeChild(element);
        document.body.removeChild(stylesElement);
        observerOnResize.disconnect();
      } catch (e) {
      }
    }
  });

  const adaptingSizeToScreen = () => {

    if (configuration.hasExtraHTML && window.screen.width >= 910 && platform.type !== 'mobile') return;

    if (configuration.hasExtraHTML && window.screen.width >= 364 && platform.type === 'mobile') return;

    if (configuration.hasExtraHTML && window.screen.width < 910 && platform.type !== 'mobile') {
      element.classList.add(`${_}adaptation__element_extraHTML`);
      box.classList.add(`${_}adaptation__box__extraHTML`);

      return;
    }

    if (configuration.hasExtraHTML && window.screen.width < 364 && platform.type === 'mobile') {
      element.classList.add(`${_}adaptation__element_extraHTML`);
      box.classList.add(`${_}adaptation__box__extraHTML`);

      return;
    }

    const excessWidth = window.matchMedia(`(max-height: ${initialHeight + 48}px)`).matches;
    const excessHeight = window.matchMedia(`(max-width: ${initialWidth + 48}px)`).matches;

    if (excessWidth || excessHeight) {
      element.classList.add(`${_}adaptation__element`);
      box.classList.add(`${_}adaptation__box`);

      return;
    }

    element.classList.remove(`${_}adaptation__element`);
    box.classList.remove(`${_}adaptation__box`);
  };

  adaptingSizeToScreen();

  const observerOnResize = new ObserverOnResize();
  observerOnResize.addForObservation(
    element,
    adaptingSizeToScreen
  );

  if (configuration.isLightbox && configuration.closeOnOverlay) {
    element.addEventListener('click', (e) => {
      e.preventDefault();

      if (e.target === e.currentTarget) {
        timer.clear();
        hideNotification(element, stylesElement);
      }
    });
  }

  if (privacyPolicyLink) {
    privacyPolicyLink.addEventListener('click', (e) => {
      window.open(`${origin}/${LINK_FOR_PERSONAL_POLICY}`, '_blank');
      e.stopPropagation();
    });
  }

  if (closeElement) {
    closeElement.addEventListener('click', () => {
      timer.clear();

      if (configuration.isCustom) {
        RS.scenarioEvent.set('TRIGGER_EVENT', [
          { TRIGGER_UUID: configuration.uuid },
          { TRIGGER_ELEMENT: 'CLOSE_WIDGET' },
          { SESSION_ID: sessionId },
        ]);
      }

      hideNotification(element, stylesElement);
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', (e) => {
      e.preventDefault();

      if (configuration.isCustom) {
        RS.scenarioEvent.set('TRIGGER_EVENT', [
          { TRIGGER_UUID: configuration.uuid },
          { TRIGGER_ELEMENT: 'CLOSE_WIDGET' },
          { SESSION_ID: sessionId },
        ]);
      }

      timer.clear();
      hideNotification(element, stylesElement);
    });
  }

  const handleButtonDisabledMode = () => {
    const isInputEmpty = input.value.replace(/\s/g, '').length < 1;

    if (
      isInputEmpty ||
      (!checkboxInput.checked && !agreeButton.hasAttribute('disabled'))
    ) {
      agreeButton.setAttribute('disabled', 'true');
    }

    if (
      !isInputEmpty &&
      checkboxInput.checked &&
      agreeButton.hasAttribute('disabled')
    ) {
      agreeButton.removeAttribute('disabled');
    }
  };

  configuration.hasPrivacyPolicy && handleButtonDisabledMode();

  if (
    checkboxWrapper &&
    checkboxInput
  ) {
    const handleRequiredCheckboxChange = ({
                                            checkboxWrapper,
                                            checkboxInput,
                                            checkboxSquare,
                                          }) => {
      if (checkboxInput.checked) {
        checkboxWrapper.classList.remove('_checked');
        checkboxInput.checked = false;
        checkboxSquare.style.backgroundColor = 'transparent';
        checkboxSquare.style.borderColor = '#F8F6FB';
      } else {
        checkboxWrapper.classList.add('_checked');
        checkboxInput.checked = true;
        checkboxSquare.style.backgroundColor = configuration.checkboxColor;
        checkboxSquare.style.borderColor = configuration.checkboxColor;
      }
    };

    const handleCheckboxChange = (e) => {
      e.preventDefault();
      handleRequiredCheckboxChange({
        checkboxWrapper,
        checkboxInput,
        checkboxSquare,
      });
      handleButtonDisabledMode();
    };

    checkboxWrapper.addEventListener('click', handleCheckboxChange);
  }

  if (input) {
    input.addEventListener('input', () => {
      handleButtonDisabledMode();
    });
  }

  if (agreeButton) {
    agreeButton.addEventListener('click', async (e) => {
      e.preventDefault();

      const patterns = {
        email:
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        phone: /^\+?\d{6,12}$/,
      };

      const isInputValid =
        configuration.inputType &&
        patterns[configuration.inputType].test(input?.value);

      const successText = 'Заявка отправлена';
      const isButtonDisabled = e.target.textContent === 'Заявка отправлена';

      if (
        inputWrapper &&
        input &&
        configuration.hasPrivacyPolicy &&
        !isButtonDisabled
      ) {
        if (isInputValid && inputWrapper.classList.contains('_failure')) {
          inputWrapper.classList.remove('_failure');
        }

        if (!isInputValid && !inputWrapper.classList.contains('_failure')) {
          inputWrapper.classList.add('_failure');
        }
      }

      const InputTypeEnum = Object.freeze({ phone: 'phone', email: 'email' });

      if (configuration.hasPrivacyPolicy && isInputValid && !isButtonDisabled) {
        try {
          const response = await RS.createLead.set(
            configuration.uuid,
            configuration.inputType === InputTypeEnum.phone ? input.value : null,
            configuration.inputType === InputTypeEnum.email ? input.value : null,
            checkboxInput.checked
          );

          if (response?.errorData.errorFlag === false) {
            e.target.textContent = successText;
            RS.scenarioEvent.set('TRIGGER_EVENT', [
              { TRIGGER_UUID: configuration.uuid },
              { TRIGGER_ELEMENT: 'WIDGET_CREATE_LEAD' },
              { SESSION_ID: sessionId },
            ]);
          }
        } catch (e) {
          throw e;
        } finally {
          setTimeout(() => {
            hideNotification(element, stylesElement);
          }, 1000);
        }
      }

      if (!configuration.hasPrivacyPolicy) {
        if (e.target.href) {
          window.setTimeout(
            () => {
              location.href = e.target.href;
            },
            buttonTimeout,
            e
          );

          if (configuration.isCustom) {
            RS.scenarioEvent.set('TRIGGER_EVENT', [
              { TRIGGER_UUID: configuration.uuid },
              { TRIGGER_ELEMENT: 'WIDGET_GOTO_HREF' },
              { SESSION_ID: sessionId },
            ]);
          }

          hideNotification(element, stylesElement);
        }

        if (configuration.scrollTo) {
          if (configuration.isCustom) {
            RS.scenarioEvent.set('TRIGGER_EVENT', [
              { TRIGGER_UUID: configuration.uuid },
              { TRIGGER_ELEMENT: 'WIDGET_SCROLL' },
              { SESSION_ID: sessionId },
            ]);
          }

          hideNotification(element, stylesElement);
        }

        if (!configuration.hasCoupon && !configuration.buttonHREF) {
          if (configuration.isCustom) {
            RS.scenarioEvent.set('TRIGGER_EVENT', [
              { TRIGGER_UUID: configuration.uuid },
              { TRIGGER_ELEMENT: 'BUTTON_CLOSE_WIDGET' },
              { SESSION_ID: sessionId },
            ]);
          }

          hideNotification(element, stylesElement);
        }
      }
    });
  }

  if (coupon) {
    agreeButton.addEventListener('click', () => {
      coupon.classList.add('_open');
      if (couponOverlay) {
        if (configuration.isCustom) {
          RS.scenarioEvent.set('TRIGGER_EVENT', [
            { TRIGGER_UUID: configuration.uuid },
            { TRIGGER_ELEMENT: 'WIDGET_OPEN_COUPON' },
            { SESSION_ID: sessionId },
          ]);
        }

        couponOverlay.parentNode.removeChild(couponOverlay);
      }
    });
  }

  if (couponTextHidden) {
    agreeButton.addEventListener('click', () => {
      if (configuration.isCustom) {
        RS.scenarioEvent.set('TRIGGER_EVENT', [
          { TRIGGER_UUID: configuration.uuid },
          { TRIGGER_ELEMENT: 'WIDGET_OPEN_COUPON' },
          { SESSION_ID: sessionId },
        ]);
      }

      couponTextHidden.classList.remove('_hidden');
    });
  }

  setTimeout(() => {
    showNotification(element);
    timer.start();
  }, 1000 / 60);

  iterator += 1;

  return Promise.resolve('OK');
};
